import useWindowSize from '../hooks/useWindowSize';

export function clampVW(minPX: number, vw: number, maxPX: number) {
  const { width } = useWindowSize();

  if (!width) return minPX;

  let size = (width * vw) / 100;
  size = size > maxPX ? maxPX : size;
  size = size < minPX ? minPX : size;

  return size;
}

export function clampVH(minPX: number, vh: number, maxPX: number) {
  const { height } = useWindowSize();

  if (!height) return minPX;

  let size = (height * vh) / 100;
  size = size > maxPX ? maxPX : size;
  size = size < minPX ? minPX : size;

  return size;
}
